// extracted by mini-css-extract-plugin
module.exports = {"sort":"oR","sortSelect":"pR","disabled":"qR"};